import { Injectable } from '@angular/core';
import {Client, ClientList} from './client';
import {BaseService} from '../base/base.service';
import {ClientSerializer} from 'src/app/clients/client.serializer';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {filter, map, take} from 'rxjs/operators';
import {InvoiceSerializer} from '../invoices/invoice.serializer';
import {Observable} from 'rxjs';
import {Invoice} from '../invoices/invoice';
import {Group} from '../filter/group';
import {Filter} from '../filter/filter';
import {Predicate} from '../shared/enums/predicate.enum';
import {Page} from '../shared/models/page';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends BaseService<Client, ClientList> {

  constructor(http: HttpClient, private invoiceSerializer: InvoiceSerializer) {
    super(http);
    this.endpoint = 'clients' ;
    this.serializer = new ClientSerializer();
  }

  fetchNextInvoice(id: number): Observable<Invoice> {
    return this.http.get<Invoice>(`${environment.base_url + this.endpoint}/${id}/next_invoice`).pipe(
      filter(x => !!x),
      take(1),
      map((res) => this.invoiceSerializer.fromJson(res))
    );
  }

  searchByName(term: string, limit = 10): Observable<Client[]> {
    const group = new Group({
      m: 'and',
      filter: term.split(/[\s,;]+/).filter(Boolean).map(word => new Filter({subject: 'name', predicate: Predicate.CONTAINS, object1: word}))
    });
    const page = Object.assign(new Page(), {offset: 0, size: limit});

    return this.fetchPage(page, [group], [{name: 'name', dir: 'asc'}], 'id,name,company,contact,zip,city').pipe(
      take(1),
      map(list => list.data)
    );
  }

  send_welcome_mail(id: number) {
    return this.http.post<void>(`${environment.base_url + this.endpoint}/${id}/send_welcome_mail`, null);
  }

}
